import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AjaxLoaderService } from './ajaxLoader.service';

@Injectable()
export class JwtHttpInterceptor implements HttpInterceptor
{
	constructor(private router: Router, private ajaxLoader: AjaxLoaderService)
	{

	}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
	{
		// ajax loader
		if (request.url.indexOf('api/contributors/contributors/getProsumerRate') < 0)
			this.ajaxLoader.show();

		let accessToken = localStorage.getItem("access_token");

		if (accessToken)
		{
			request = request.clone({
				setHeaders: {
					Authorization: `Bearer ${accessToken}`
				}
			});
		}

		return next.handle(request).pipe(tap(
			(event: HttpEvent<any>) =>
			{
				if (event instanceof HttpResponse)
				{
					// ajax loader
					this.ajaxLoader.hide();
				}
			},
			(err: any) =>
			{
				if (err instanceof HttpErrorResponse)
				{
					// Unauthorized
					if (err.status === 401)
					{
						this.router.navigate(['login'], { queryParams: { returnUrl: this.router.url } });
					}

					// forbidden
					if (err.status === 403)
					{
						this.router.navigate(['forbidden']);
					}

					// ajax loader
					this.ajaxLoader.hide();
				}
			}
		));
	}
}